import script from "./BrushMapListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./BrushMapListItem.vue?vue&type=script&lang=ts&setup=true"

import "./BrushMapListItem.vue?vue&type=style&index=0&id=1ca41ce4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca41ce4"]])

export default __exports__